import { UserModel, CompanyModel } from '@/types';

export interface AuthState {
    user?: UserModel;
    company?: CompanyModel;
}
